import "./Sidebar.css";
import { Link, useLocation } from "react-router-dom";
import SideNav, { NavItem, NavIcon, NavText } from "@trendmicro/react-sidenav";
import "@trendmicro/react-sidenav/dist/react-sidenav.css";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { getPermissionsByEmailId, sellerListBackDetails, userListBackDetails } from "../../store/actions";
import { Tooltip as WmsTooltip } from "react-tooltip";
import management from "../../../src/assets/management.png";
import incomingIcon from "../../../src/assets/incoming-icon.png";
import { inboundBackDetails, InventoryProductBackDetails, outboundBackDetails, taskBackDetails } from "../../store/actions/employee";
import { packageBackDetails, packagesYearBackDetails, productYearBackDetails, productBackDetails, packageApprovalBackDetails } from "../../store/actions/incoming";
import { companyListBackDetails } from "../../store/actions/rateCard";
import { transformData } from "../../config/utils";
import _ from "lodash";
import TaskIcon from "../../assets/task.svg";
import PropTypes from "prop-types";
import { getDropshipSetting } from "../../store/actions/dropship.action";


const Sidebar = ({ sidebarOpen }, props) => {
    const [expanded, setExpanded] = useState(false);
    const myRef = useRef();
    const dispatch = useDispatch();
    const employeePermissions = useSelector((state) => state?.sidebar?.employeePermissions);
    const userDetails = useSelector((state) => state.auth.user);
    const isDropshipEnabled = useSelector((state) => state?.dropshipReducer?.isDropshipEnabled);
    const handleClickOutside = (e) => {
        if (!myRef.current.contains(e.target)) {
            setExpanded(false);
        }
    };
    const [permissionData, setPermissionData] = useState({});
    const location = useLocation();
    const path = location.pathname;
    
    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    });

    /**
     * Get logged in user permissions by email id
     */
    useEffect(() => {
        dispatch(getPermissionsByEmailId());
        dispatch(getDropshipSetting({}));
    }, []);

    useEffect(() => {
        if (employeePermissions?.length) {
            let permissionDataObj = transformData(employeePermissions)
            setPermissionData(permissionDataObj)
        }
    }, [employeePermissions]);

    /**
     * Handle menu click
     */
    const handleMenuClick = () => {
        myRef.current.click()
    }

    const renderDropshipSection = () => {
        if (!isDropshipEnabled) return null;
        return (
            <NavItem eventKey="/dropship" active={path.includes("dropship")}>
                <NavIcon>
                    <div className="mainMenu">
                        <i className="fa fa-exchange" style={{ fontSize: "1em" }} aria-hidden="true" />
                    </div>
                </NavIcon>

                <NavItem eventKey="/dropship/explore" className="menuItem SubMenu" active={path.includes("dropship/explore")}>
                    <NavIcon>
                        <Link to="/dropship/explore">
                            <span><i className="fa fa-search" style={{ fontSize: "1em" }} /></span>
                        </Link>
                    </NavIcon>
                    <NavText>
                        <span className="spanWrapper"><Link to="/dropship/explore">Explore Products</Link></span>
                    </NavText>
                </NavItem>

                <NavItem eventKey="/dropship/agreements" className="menuItem SubMenu" active={path.includes("dropship/agreements")}>
                    <NavIcon>
                        <Link to="/dropship/agreements">
                            <span><i className="fa fa-handshake-o" style={{ fontSize: "1em" }} /></span>
                        </Link>
                    </NavIcon>
                    <NavText>
                        <span className="spanWrapper"><Link to="/dropship/agreements">My Imports</Link></span>
                    </NavText>
                </NavItem>

                <NavItem eventKey="/dropship/fulfillment" className="menuItem SubMenu" active={path.includes("dropship/fulfillment")}>
                    <NavIcon>
                        <Link to="/dropship/fulfillment">
                            <span><i className="fa fa-truck" style={{ fontSize: "1em" }} /></span>
                        </Link>
                    </NavIcon>
                    <NavText>
                        <span className="spanWrapper"><Link to="/dropship/fulfillment">Fulfillment</Link></span>
                    </NavText>
                </NavItem>

                <NavText>Dropshipping</NavText>
            </NavItem>
        );
    };

    const renderReportsSection = () => {
        if (!permissionData?.FEATURE_REPORTS?.permissionHave) return null;
        return (
            <NavItem className="mainMenu" eventKey="/reports" active={path.includes("/reports")}>
                <NavIcon id="reportsIcon">
                    <Link to="/reports" className="menuOuter">
                        <i
                            className="fa fa-line-chart"
                            style={{ fontSize: "1em" }}
                            aria-hidden="true"
                        />
                    </Link>
                </NavIcon>
                <WmsTooltip
                    anchorId={"reportsIcon"}
                    place="right"
                    content={"Reports"}
                />
                <NavText>
                    <Link to="reports" className="menuOuter">Reports</Link>
                </NavText>
            </NavItem>
        );
    };

    const renderOrdersManagementSection = () => {
        const orders = permissionData?.FEATURE_ORDERSMANAGEMENT;
        if (!orders?.permissionHave) return null;
        const sub = orders.SubFeatures || {};
        return (
            <NavItem
                eventKey="shipment"
                active={
                    path === "/scan-form" ||
                    path === "/shipment" ||
                    path === "/BatchShipping" ||
                    path === "/trackhistory"
                }
            >
                <NavIcon id="shipmentIcon">
                    <div className="mainMenu">
                        <i className="fa fa-cube" style={{ fontSize: "1em" }} />
                    </div>
                </NavIcon>
                {sub?.SUBF_SHIPMENT?.permissionHave && (
                    <NavItem
                        eventKey="shipment"
                        className="menuItem SubMenu"
                        active={path === "/shipment"}
                        onClick={handleMenuClick}
                    >
                        <NavIcon id="batchIcon">
                            <Link to="shipment">
                                <i
                                    className="fa fa-fw fa-solid fa-cube"
                                    style={{ fontSize: "1em" }}
                                />
                            </Link>
                        </NavIcon>
                        <NavText>
                            <Link to="shipment">Shipment</Link>
                        </NavText>
                    </NavItem>
                )}

                {sub?.SUBF_BATCHSHIPPING?.permissionHave && (
                    <NavItem
                        eventKey="batchShipping"
                        className="menuItem SubMenu"
                        active={path === "/BatchShipping"}
                    >
                        <NavIcon id="batchIcon">
                            <Link to="BatchShipping">
                                <div className="mainMenu">
                                    <i>
                                        <svg
                                            width="12"
                                            height="16"
                                            fill="currentColor"
                                            className="bi bi-back"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H2a2 2 0 0 1-2-2V2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2z" />
                                        </svg>
                                    </i>
                                </div>
                            </Link>
                        </NavIcon>
                        <NavText>
                            <Link to="BatchShipping">Batch Shipping</Link>
                        </NavText>
                    </NavItem>
                )}

                {sub?.SUBF_HISTORYTRACK?.permissionHave && (
                    <NavItem
                        eventKey="trackhistory"
                        className="menuItem SubMenu"
                        active={path === "/trackhistory"}
                    >
                        <NavIcon>
                            <Link to="trackhistory">
                                <i
                                    className="fa fa-history"
                                    style={{ fontSize: "1em" }}
                                />
                            </Link>
                        </NavIcon>
                        <NavText>
                            <Link to="trackhistory">History/Track</Link>
                        </NavText>
                    </NavItem>
                )}
                {sub?.SUBF_SCANFORMS?.permissionHave && (
                    <NavItem
                        eventKey="ScanForms"
                        className="menuItem SubMenu"
                        active={path === "/scan-form"}
                    >
                        <NavIcon>
                            <Link to="trackhistory">
                                <i className="fa fa-qrcode" style={{ fontSize: "1em" }} />
                            </Link>
                        </NavIcon>
                        <NavText>
                            <Link to="scan-form">Scan Forms</Link>
                        </NavText>
                    </NavItem>
                )}
                {sub?.SUBF_SCANFORMS?.permissionHave && (
                    <NavItem
                        eventKey="ScanForms"
                        className="menuItem SubMenu"
                        active={path === "/refunds"}
                    >
                        <NavIcon>
                            <Link to="trackhistory">
                                <i className="fa fa-repeat" style={{ fontSize: "1.15em" }} />
                            </Link>
                        </NavIcon>
                        <NavText>
                            <Link to="refunds">Refunds</Link>
                        </NavText>
                    </NavItem>
                )}
                <NavText>Orders Management</NavText>
            </NavItem>
        );
    };

    const renderAccountManagementSection = () => {
        const account = permissionData?.FEATURE_ACCOUNTMANAGEMENT;
        if (!account?.permissionHave) return null;
        const sub = account.SubFeatures || {};

        const hasUserAccess = sub?.SUBF_USER?.permissionHave;
        const hasUserRequestAccess = sub?.SUBF_USERREQUESTS?.permissionHave;
        return (
            <NavItem
                eventKey="companySeller"
                active={
                    path === "/CompanyManagement" || path === "/sellerManagement" || path.includes('editUser') || path.includes('editSeller') || path.includes('editCompany')
                }
            >
                <NavIcon id="companyIcon2">
                    <img className="fa imageIco" src={management} alt="" />
                </NavIcon>
                {sub?.SUBF_COMPANY?.permissionHave && (
                    <NavItem
                        eventKey="/CompanyManagement"
                        className="menuItem SubMenu"
                        active={path === "/CompanyManagement"}
                    >
                        <NavIcon id="addCompany">
                            <Link to="/CompanyManagement">
                                <span>
                                    <i
                                        className="fa fa-building-o"
                                        style={{ fontSize: "1em" }}
                                    />
                                </span>
                            </Link>
                        </NavIcon>
                        <WmsTooltip
                            anchorId={"addCompany"}
                            place="right"
                            content={"Company"}
                        />
                        <NavText>
                            <button 
                                type="button"
                                className={`${path === "/CompanyManagement" ? "spanWrapper sortBtn active userMenuBtn" : "userMenuBtn"}`}
                                onClick={() => dispatch(companyListBackDetails({}))}
                            >
                                <Link to="CompanyManagement">Company</Link>
                            </button>
                        </NavText>
                    </NavItem>
                )}
                {sub?.SUBF_SELLER?.permissionHave && (
                    <NavItem
                        eventKey="/SellerManagement"
                        className="menuItem SubMenu"
                        active={path === "/SellerManagement"}
                    >
                        <NavIcon id="addSeller">
                            <Link to="/SellerManagement">
                                <span>
                                    <i
                                        className="fa fa-user-o"
                                        style={{ fontSize: "1em" }}
                                    />
                                </span>
                            </Link>
                        </NavIcon>
                        <WmsTooltip
                            anchorId={"addSeller"}
                            place="right"
                            content={"Seller"}
                        />
                        <NavText>
                            <button 
                                type="button"
                                className={`${path === "/SellerManagement" ? "spanWrapper sortBtn active userMenuBtn" : "userMenuBtn"}`}
                                onClick={() => dispatch(sellerListBackDetails({}))}
                            >
                                <Link to="/SellerManagement"> Seller</Link>
                            </button>
                        </NavText>
                    </NavItem>
                )}
                {hasUserAccess && (
                    <NavItem
                        eventKey="shipment"
                        className="menuItem SubMenu"
                        active={path === "/userManagement"}
                    >
                        <NavIcon id="batchIcon">
                            <Link>
                                <i className="fa fa-users" style={{ fontSize: "1em" }} />
                            </Link>
                        </NavIcon>
                        <NavText>
                            <button 
                                type="button"
                                className={`${path === "/userManagement" ? "spanWrapper sortBtn active userMenuBtn" : "userMenuBtn"}`}
                                onClick={() => dispatch(userListBackDetails({}))}
                            >
                                <Link to="/userManagement">Users</Link>
                            </button>
                        </NavText>
                    </NavItem>
                )}
                {hasUserRequestAccess && (
                    <NavItem
                        eventKey="shipment"
                        className="menuItem SubMenu"
                        active={path === "/user-request"}
                    >
                        <NavIcon id="batchIcon">
                            <Link>
                                <i className="fa fa-user-o" style={{ fontSize: "1em" }} />
                            </Link>
                        </NavIcon>
                        <NavText>
                            <button 
                                type="button"
                                className={`${path === "/user-request" ? "spanWrapper sortBtn active userMenuBtn" : "userMenuBtn"}`}
                                onClick={() => dispatch(userListBackDetails({}))}
                            >
                                <Link to="/user-request">User Requests</Link>
                            </button>
                        </NavText>
                    </NavItem>
                )}
                <NavText>Account Management</NavText>
            </NavItem>
        );
    };

    return (
        <div
            ref={myRef}
            className={sidebarOpen ? "sidebar" : "leftSideBar"}
            id="sidebar"
        >
            <button className="hamburgerMenu" onClick={() => setExpanded(!expanded)}>
                <i className="fa fa-bars" aria-hidden="true"></i>
            </button>
            <SideNav
                onSelect={(selected) => {
                    setExpanded(false);
                }}
                onToggle={(expand) => setExpanded(expand)}
                expanded={expanded}
                className={`${expanded ? 'expandedMenu' : 'menuWrapper'}`}
            >
                <SideNav.Toggle className="hamburgerMenu" />
                {!_.isEmpty(permissionData) && (
                    <SideNav.Nav className="menuContainer">
                        <NavItem eventKey="Dashboard" active={path === "/"}>
                            <NavIcon id="home">
                                <Link to="/">
                                    <div className="mainMenu">
                                        <i className="fa fa-fw fa fa-tachometer" style={{ fontSize: "1em" }} />
                                    </div>
                                </Link>
                            </NavIcon>
                            <WmsTooltip anchorId={"home"} place="right" content={"Home"} />
                            <NavText className="mainMenu">
                                <Link to="/">Home</Link>
                            </NavText>
                        </NavItem>
                        {permissionData?.FEATURE_ONBOARDINGDETAILS?.permissionHave && (
                            <NavItem eventKey="SellerOnboarding" active={path === "/user-onboarding"}>
                                <NavIcon id="sellerOnboarding">
                                    <Link to="/user-onboarding">
                                        <div className="mainMenu">
                                            <i className="fa fa-id-card-o" style={{ fontSize: "1em" }} />
                                        </div>
                                    </Link>
                                </NavIcon>
                                <WmsTooltip anchorId={"sellerOnboarding"} place="right" content={"Onboarding Details"} />
                                <NavText className="mainMenu">
                                    <Link to="/user-onboarding">Onboarding Details</Link>
                                </NavText>
                            </NavItem>
                        )}
                        {permissionData?.FEATURE_TASKMANAGEMENT?.permissionHave && (
                            <NavItem eventKey="Dashboard" active={path.includes("/tasks")}>
                                <NavIcon id="tasks" onClick={() => dispatch(taskBackDetails({}))}>
                                    <Link to="/tasks">
                                        <div className="mainMenu faTask fa">
                                            <img
                                                alt="Premium logo"
                                                className="taskIcon"
                                                src={TaskIcon}
                                            />
                                        </div>
                                    </Link>
                                </NavIcon>
                                <WmsTooltip anchorId={"tasks"} place="right" content={"Tasks"} />
                                <NavText className="mainMenu">
                                    <Link to="/tasks">Tasks</Link>
                                </NavText>
                            </NavItem>
                        )}

                        {renderOrdersManagementSection()}

                        {permissionData?.FEATURE_CARRIERCONNECTMANAGEMENT?.permissionHave && (
                            <NavItem 
                                eventKey="/carrier-connect" 
                                active={path.includes("/carrier-connect")}
                            >
                                <NavIcon id="carrierConnectIcon">
                                    <div className="mainMenu">
                                        <i
                                            className="fa fa-fw fa-link"
                                            style={{ fontSize: "1em" }}
                                            aria-hidden="true"
                                        />
                                    </div>
                                </NavIcon>
                                
                                {/* Carrier Connect Listing */}
                                <NavItem
                                    eventKey="/carrier-connect"
                                    className="menuItem SubMenu"
                                    active={path === "/carrier-connect"}
                                >
                                    <NavIcon>
                                        <Link to="/carrier-connect">
                                            <i
                                                className="fa fa-list"
                                                style={{ fontSize: "1em" }}
                                            />
                                        </Link>
                                    </NavIcon>
                                    <NavText>
                                        <Link to="/carrier-connect">Carrier Connect</Link>
                                    </NavText>
                                </NavItem>

                                {/* Assignment Approval - Super Admin Only */}
                                {permissionData?.FEATURE_CARRIERCONNECTMANAGEMENT?.SubFeatures?.SUBF_ASSIGNMENTAPPROVAL?.permissionHave && (
                                    <NavItem
                                        eventKey="/carrier-connect/assignment-approval"
                                        className="menuItem SubMenu"
                                        active={path === "/carrier-connect/assignment-approval"}
                                    >
                                        <NavIcon>
                                            <Link to="/carrier-connect/assignment-approval">
                                                <i
                                                    className="fa fa-check-square-o"
                                                    style={{ fontSize: "1em" }}
                                                />
                                            </Link>
                                        </NavIcon>
                                        <NavText>
                                            <Link to="/carrier-connect/assignment-approval">Assignment Approval</Link>
                                        </NavText>
                                    </NavItem>
                                )}

                                <NavText>Carrier Connect Management</NavText>
                            </NavItem>
                        )}

                        {permissionData?.FEATURE_ADDRESSBOOK?.permissionHave && (
                            <NavItem eventKey="address-book" active={path === "/address-book"}>
                                <NavIcon id="address-book">
                                    <Link to="/address-book" className="menuOuter mainMenu">
                                        <i
                                            className="fa fa-address-book-o"
                                            style={{ fontSize: "1em" }}
                                            aria-hidden="true"
                                        />
                                    </Link>
                                </NavIcon>
                                <WmsTooltip
                                    anchorId={"address-book"}
                                    place="right"
                                    content={"Address Book"}
                                />
                                <NavText>
                                    <Link to="/address-book" className="menuOuter">Address Book</Link>
                                </NavText>
                            </NavItem>
                        )}

                        {permissionData?.FEATURE_RETURNSMANAGEMENT?.permissionHave && (
                            <NavItem
                                eventKey="Incoming"
                                active={
                                    path.includes("incoming-packages") || path.includes("incoming-product")
                                }
                            >
                                <NavIcon id="companyIcon">
                                    <img className="fa imageIco" src={incomingIcon} alt="" />
                                </NavIcon>
                                {permissionData?.FEATURE_RETURNSMANAGEMENT?.SubFeatures?.SUBF_PACKAGES?.permissionHave && (
                                    <NavItem
                                        eventKey="/incoming-packages"
                                        className="menuItem SubMenu"
                                        active={path.includes("/incoming-packages")}
                                    >
                                        <NavIcon id="incomingIcon">
                                            <Link to="/incoming-packages">
                                                <i
                                                    className="fa fa-archive mainMenu"
                                                    style={{ fontSize: "1em" }}
                                                    aria-hidden="true"
                                                />
                                            </Link>
                                        </NavIcon>
                                        <WmsTooltip
                                            anchorId={"incomingIcon"}
                                            place="right"
                                            content={"Packages"}
                                        />
                                        <NavText>
                                            <div className="inactiveMenu">Return Packages</div>
                                            <button
                                                className={`${(path.endsWith("/incoming-packages")) ? "spanWrapper sortBtn active userMenuBtn pl-2" : "userMenuBtn pl-2"}`}
                                                onClick={() => {
                                                    dispatch(productYearBackDetails(0));
                                                    dispatch(productBackDetails({}));
                                                }}
                                            >
                                                <Link to="/incoming-packages">Summary View</Link>
                                            </button>
                                            <button
                                                className={`${(path.includes("/incoming-packages/package-details")) ? "spanWrapper sortBtn active userMenuBtn pl-2" : "userMenuBtn pl-2"}`}
                                                onClick={() => {
                                                    dispatch(productYearBackDetails(0));
                                                    dispatch(productBackDetails({}));
                                                }}
                                            >
                                                <Link to="/incoming-packages/package-details" state={{ date: new Date(), fromMainPage: true }}>Detail View</Link>
                                            </button>
                                        </NavText>
                                    </NavItem>
                                )}
                                {permissionData?.FEATURE_RETURNSMANAGEMENT?.SubFeatures?.SUBF_PRODUCTS?.permissionHave && (
                                    <NavItem
                                        eventKey="/incoming-packages"
                                        className="menuItem SubMenu"
                                        active={(path.includes("/incoming-products") || (path.includes("/incoming-product") && !path.includes("incoming-product-listing")))}
                                    >
                                        <NavIcon id="productIcon">
                                            <Link to="/incoming-products">
                                                <i
                                                    className="fa fa-cubes"
                                                    style={{ fontSize: "1em" }}
                                                    aria-hidden="true"
                                                />
                                            </Link>
                                        </NavIcon>
                                        <WmsTooltip
                                            anchorId={"productIcon"}
                                            place="right"
                                            content={"Product"}
                                        />
                                        <NavText>
                                            <div className="inactiveMenu">Return Products</div>
                                            <button
                                                className={`${(path.endsWith("/incoming-products")) ? "spanWrapper sortBtn active userMenuBtn pl-2" : "userMenuBtn pl-2"}`}
                                                onClick={() => {
                                                    dispatch(productYearBackDetails(0));
                                                    dispatch(productBackDetails({}));
                                                }}
                                            >
                                                <Link to="/incoming-products">Summary View</Link>
                                            </button>
                                            <button
                                                className={`${(path.includes("/product-details")) ? "spanWrapper sortBtn active userMenuBtn pl-2" : "userMenuBtn pl-2"}`}
                                                onClick={() => {
                                                    dispatch(productYearBackDetails(0));
                                                    dispatch(productBackDetails({}));
                                                }}
                                            >
                                                <Link to="/incoming-products/product-details" state={{ date: new Date(), fromMainPage: true }}>Detail View</Link>
                                            </button>
                                        </NavText>
                                    </NavItem>
                                )}
                                {permissionData?.FEATURE_RETURNSMANAGEMENT?.SubFeatures?.SUBF_PRODUCTLISTING?.permissionHave && (
                                    <NavItem
                                        eventKey="/incoming-product-listing"
                                        className="menuItem SubMenu"
                                        active={path === "/incoming-product-listing"}
                                    >
                                        <NavIcon id="incomingIcon">
                                            <Link to="/incoming-product-listing">
                                                <i
                                                    className="fa fa-list-alt"
                                                    style={{ fontSize: "1em" }}
                                                    aria-hidden="true"
                                                />
                                            </Link>
                                        </NavIcon>
                                        <WmsTooltip
                                            anchorId={"incomingIcon"}
                                            place="right"
                                            content={"ProductListing"}
                                        />
                                        <NavText>
                                            <span className="spanWrapper">
                                                <Link to="/incoming-product-listing">Product Listing</Link>
                                            </span>
                                        </NavText>
                                    </NavItem>
                                )}
                                <NavItem
                                    eventKey="/incoming-bulk-upload"
                                    className="menuItem SubMenu"
                                    active={path === "/incoming-bulk-upload"}
                                >
                                    <NavIcon id="incomingIcon">
                                        <Link to="/incoming-bulk-upload">
                                            <i
                                                className="fa fa-upload"
                                                style={{ fontSize: "1em" }}
                                                aria-hidden="true"
                                            />
                                        </Link>
                                    </NavIcon>
                                    <WmsTooltip
                                        anchorId={"incomingIcon"}
                                        place="right"
                                        content={"Bulkupload"}
                                    />
                                    <NavText>
                                        <span className="spanWrapper">
                                            <Link to="/incoming-bulk-upload">Bulk Upload</Link>
                                        </span>
                                    </NavText>
                                </NavItem>
                                {userDetails?.Value?.isSuperAdmin && (
                                    <NavItem
                                        eventKey="/package-assignment-approval"
                                        className="menuItem SubMenu"
                                        active={path === "/package-assignment-approval"}
                                    >
                                        <NavIcon id="packageAssignmentIcon">
                                            <Link to="/package-assignment-approval">
                                                <i
                                                    className="fa fa-check-square"
                                                    aria-hidden="true"
                                                />
                                            </Link>
                                        </NavIcon>
                                        <WmsTooltip
                                            anchorId={"packageAssignmentIcon"}
                                            place="right"
                                            content={"Package Assignment Approval"}
                                        />
                                        <NavText>
                                            <button
                                                className={`${path.includes("/package-assignment-approval") ? "spanWrapper sortBtn active userMenuBtn" : "userMenuBtn"}`}
                                                onClick={() => {
                                                    dispatch(packageApprovalBackDetails({}));
                                                }}
                                            >
                                                <span className="spanWrapper">
                                                    <Link to="/package-assignment-approval" style={{lineHeight: 1.5, paddingTop: '8px'}}>Package Assignment Approval</Link>
                                                </span>
                                            </button>
                                        </NavText>
                                    </NavItem>
                                )}
                                <NavText>Returns Management</NavText>
                            </NavItem>
                        )}

                        {renderAccountManagementSection()}

                        {permissionData?.FEATURE_INVENTORYMANAGEMENT?.permissionHave && (
                            <NavItem
                                eventKey="inventoryManagement"
                                active={
                                    path === "/inventory"
                                }
                            >
                                <NavIcon id="companyIcon">
                                    <div className="mainMenu">
                                        <i
                                            className="fa fa-cubes"
                                            style={{ fontSize: "1em" }}
                                            aria-hidden="true"
                                        />
                                    </div>
                                </NavIcon>
                                {permissionData?.FEATURE_INVENTORYMANAGEMENT?.SubFeatures?.SUBF_LISTING?.permissionHave && (
                                    <NavItem
                                        eventKey="/inventory"
                                        className="menuItem SubMenu"
                                        active={path.includes("inventory")}
                                    >
                                        <NavIcon id="addCompany">
                                            <Link to="/inventory">
                                                <span>
                                                    <i
                                                        className="fa fa-th-large"
                                                        style={{ fontSize: "1em" }}
                                                    />
                                                </span>
                                            </Link>
                                        </NavIcon>
                                        <WmsTooltip
                                            anchorId={"addCompany"}
                                            place="right"
                                            content={"Company"}
                                        />
                                        <NavText>
                                            <button
                                                className={`${path.includes("inventory") ? "spanWrapper sortBtn active userMenuBtn" : "userMenuBtn"}`}
                                                onClick={() => dispatch(InventoryProductBackDetails({}))}
                                            >
                                                <Link to="inventory">Inventory</Link>
                                            </button>
                                        </NavText>
                                    </NavItem>
                                )}
                                {permissionData?.FEATURE_INVENTORYMANAGEMENT?.SubFeatures?.SUBF_INBOUND?.permissionHave && (
                                    <NavItem
                                        eventKey="/inbound"
                                        className="menuItem SubMenu"
                                        active={path.includes("inbound")}
                                    >
                                        <NavIcon id="addCompany">
                                            <Link to="/inbound">
                                                <span>
                                                    <i
                                                        className="fa fa-archive"
                                                        style={{ fontSize: "1em" }}
                                                    />
                                                </span>
                                            </Link>
                                        </NavIcon>
                                        <WmsTooltip
                                            anchorId={"addCompany"}
                                            place="right"
                                            content={"Company"}
                                        />
                                        <NavText>
                                            <button
                                                className={`${path.includes("inbound") ? "spanWrapper sortBtn active userMenuBtn" : "userMenuBtn"}`}
                                                onClick={() => dispatch(inboundBackDetails({}))}
                                            >
                                                <Link to="inbound">Inbound</Link>
                                            </button>
                                        </NavText>
                                    </NavItem>
                                )}
                                {permissionData?.FEATURE_INVENTORYMANAGEMENT?.SubFeatures?.SUBF_OUTBOUND?.permissionHave && (
                                    <NavItem
                                        eventKey="/outbound"
                                        className="menuItem SubMenu"
                                        active={path.includes("outbound")}
                                    >
                                        <NavIcon id="addCompany">
                                            <Link to="/outbound">
                                                <span>
                                                    <i
                                                        className="fa fa-outdent"
                                                        style={{ fontSize: "1em" }}
                                                    />
                                                </span>
                                            </Link>
                                        </NavIcon>
                                        <WmsTooltip
                                            anchorId={"addCompany"}
                                            place="right"
                                            content={"Company"}
                                        />
                                        <NavText>
                                            <button
                                                className={`${path.includes("outbound") ? "spanWrapper sortBtn active userMenuBtn" : "userMenuBtn"}`}
                                                onClick={() => dispatch(outboundBackDetails({}))}
                                            >
                                                <Link to="outbound">Outbound</Link>
                                            </button>
                                        </NavText>
                                    </NavItem>
                                )}

                                {permissionData?.FEATURE_INVENTORYMANAGEMENT?.SubFeatures?.SUBF_PICKER?.permissionHave && (
                                    <NavItem
                                        eventKey="/Order-Picking"
                                        className="menuItem SubMenu"
                                        active={path.includes("Order-Picking")}
                                    >
                                        <NavIcon id="addCompany">
                                            <Link to="/Order-Picking">
                                                <span>
                                                    <i
                                                        className="fa fa-get-pocket"
                                                        style={{ fontSize: "1em" }}
                                                    />
                                                </span>
                                            </Link>
                                        </NavIcon>
                                        <NavText>
                                            <span className="spanWrapper">
                                                <Link to="Order-Picking">Order Picking Plan</Link>
                                            </span>
                                        </NavText>
                                    </NavItem>
                                )}

                                {permissionData?.FEATURE_INVENTORYMANAGEMENT?.SubFeatures?.SUBF_PACKER?.permissionHave && (
                                    <NavItem
                                        eventKey="/Order-Packing"
                                        className="menuItem SubMenu"
                                        active={path.includes("Order-Packing")}
                                    >
                                        <NavIcon id="addCompany">
                                            <Link to="/Order-Packing">
                                                <span>
                                                    <i
                                                        className="fa fa-archive"
                                                        style={{ fontSize: "1em" }}
                                                    />
                                                </span>
                                            </Link>
                                        </NavIcon>
                                        <NavText>
                                            <span className="spanWrapper">
                                                <Link to="Order-Packing">Order Packing Plan</Link>
                                            </span>
                                        </NavText>
                                    </NavItem>
                                )}

                                <NavText>Inventory Management</NavText>
                            </NavItem>
                        )}

                        {renderDropshipSection()}

                        {permissionData?.FEATURE_BARCODE?.permissionHave && (
                            <NavItem eventKey="/uploads" active={path.includes("uploads")}>
                                <NavIcon id="uploads">
                                    <div className="mainMenu">
                                        <i
                                            className="fa fa-cloud-upload"
                                            style={{ fontSize: "1em" }}
                                            aria-hidden="true"
                                        />
                                    </div>
                                </NavIcon>
                                <NavItem
                                    eventKey="/createintegration/0"
                                    className="menuItem SubMenu"
                                    active={path.includes("createintegration")}
                                >
                                    <NavIcon id="addCompany">
                                        <Link to="/createintegration/0">
                                            <span>
                                                <i
                                                    className="fa fa-file-excel-o"
                                                    style={{ fontSize: "1em" }}
                                                />
                                            </span>
                                        </Link>
                                    </NavIcon>
                                    <WmsTooltip
                                        anchorId={"addCompany"}
                                        place="right"
                                        content={"Company"}
                                    />
                                    <NavText>
                                        <span className="spanWrapper">
                                            <Link to="createintegration/0">CSV Mapping</Link>
                                        </span>
                                    </NavText>
                                </NavItem>

                                <NavItem
                                    eventKey="/uploads"
                                    className="menuItem SubMenu"
                                    active={path.includes("uploads")}
                                >
                                    <NavIcon id="addCompany">
                                        <Link to="/uploads">
                                            <span>
                                                <i
                                                    className="fa fa-upload"
                                                    style={{ fontSize: "1em" }}
                                                />
                                            </span>
                                        </Link>
                                    </NavIcon>
                                    <WmsTooltip
                                        anchorId={"addCompany"}
                                        place="right"
                                        content={"Company"}
                                    />
                                    <NavText>
                                        <span className="spanWrapper">
                                            <Link to="uploads">Bulk Upload</Link>
                                        </span>
                                    </NavText>
                                </NavItem>
                                <NavText><Link to="uploads">Uploads</Link></NavText>
                            </NavItem>
                        )}

                        {permissionData?.FEATURE_ACCOUNTS?.permissionHave && (
                            <NavItem eventKey="Accounting" active={path.includes("accounting")}>
                                <NavIcon id="accountingIcon">
                                    <div className="mainMenu">
                                        <i
                                            className="fa fa-usd"
                                            style={{ fontSize: "1em" }}
                                            aria-hidden="true"
                                        />
                                    </div>
                                </NavIcon>

                                {/* Submenu: Service Rate Card */}
                                {permissionData?.FEATURE_ACCOUNTS?.SubFeatures?.SUBF_SERVICERATECARD?.permissionHave && (
                                    <NavItem eventKey="/accounting/service-rate-card" className="menuItem SubMenu" active={path.includes("service-rate-card")}>
                                        <NavIcon id="serviceRateIcon">
                                            <Link to="/accounting/service-rate-card">
                                                <i className="fa fa-list" style={{ fontSize: "1em" }} />
                                            </Link>
                                        </NavIcon>
                                        <WmsTooltip anchorId={"serviceRateIcon"} place="right" content={"Service Rate Card"} />
                                        <NavText>
                                            <Link to="/accounting/service-rate-card">Service Rate Card</Link>
                                        </NavText>
                                    </NavItem>
                                )}

                                {/* Submenu: Ledger */}
                                {permissionData?.FEATURE_ACCOUNTS?.SubFeatures?.SUBF_LEDGER?.permissionHave && (
                                    <NavItem eventKey="/accounting/ledger" className="menuItem SubMenu" active={path.includes("ledger") && !path.includes("seller-ledger")}>
                                        <NavIcon id="ledgerIcon">
                                            <Link to="/accounting/ledger">
                                                <i className="fa fa-book" style={{ fontSize: "1em" }} />
                                            </Link>
                                        </NavIcon>
                                        <WmsTooltip anchorId={"ledgerIcon"} place="right" content={"Ledger"} />
                                        <NavText>
                                            <Link to="/accounting/ledger">Ledger</Link>
                                        </NavText>
                                    </NavItem>
                                )}

                                {/* Submenu: Seller Ledger */}
                                {permissionData?.FEATURE_ACCOUNTS?.SubFeatures?.SUBF_SELLERLEDGER?.permissionHave && (
                                    <NavItem eventKey="/accounting/seller-ledger" className="menuItem SubMenu" active={path.includes("seller-ledger")}>
                                        <NavIcon id="sellerLedgerIcon">
                                            <Link to="/accounting/seller-ledger">
                                                <i className="fa fa-address-book" style={{ fontSize: "1em" }} />
                                            </Link>
                                        </NavIcon>
                                        <WmsTooltip anchorId={"sellerLedgerIcon"} place="right" content={"Seller Ledger"} />
                                        <NavText>
                                            <Link to="/accounting/seller-ledger">Seller Ledger</Link>
                                        </NavText>
                                    </NavItem>
                                )}

                                {/* Submenu: My Invoices */}
                                {permissionData?.FEATURE_ACCOUNTS?.SubFeatures?.SUBF_MYINVOICES?.permissionHave && (
                                    <NavItem eventKey="/accounting/my-invoices" className="menuItem SubMenu" active={path.includes("my-invoices")}>
                                        <NavIcon id="myInvoicesIcon">
                                            <Link to="/accounting/my-invoices">
                                                <i className="fa fa-file-text" style={{ fontSize: "1em" }} />
                                            </Link>
                                        </NavIcon>
                                        <WmsTooltip anchorId={"myInvoicesIcon"} place="right" content={"My Invoices"} />
                                        <NavText>
                                            <Link to="/accounting/my-invoices">My Invoices</Link>
                                        </NavText>
                                    </NavItem>
                                )}

                                {/* Submenu: Invoices */}
                                {permissionData?.FEATURE_ACCOUNTS?.SubFeatures?.SUBF_INVOICES?.permissionHave && (
                                    <NavItem eventKey="/accounting/invoices" className="menuItem SubMenu" active={path.includes("invoices") && !path.includes("my-invoices")}>
                                        <NavIcon id="invoicesIcon">
                                            <Link to="/accounting/invoices">
                                                <i className="fa fa-file-text" style={{ fontSize: "1em" }} />
                                            </Link>
                                        </NavIcon>
                                        <WmsTooltip anchorId={"invoicesIcon"} place="right" content={"Invoices"} />
                                        <NavText>
                                            <Link to="/accounting/invoices">Invoices</Link>
                                        </NavText>
                                    </NavItem>
                                )}

                                {/* Submenu: Custom Pricing Templates */}
                                {permissionData?.FEATURE_ACCOUNTS?.SubFeatures?.SUBF_CUSTOMPRICINGTEMPLATES?.permissionHave && (
                                    <NavItem eventKey="/accounting/pricing-templates" className="menuItem SubMenu" active={path.includes("pricing-templates")}>
                                        <NavIcon id="pricingTemplatesIcon">
                                            <Link to="/accounting/pricing-templates">
                                                <i className="fa fa-tags" style={{ fontSize: "1em" }} />
                                            </Link>
                                        </NavIcon>
                                        <WmsTooltip anchorId={"pricingTemplatesIcon"} place="right" content={"Custom Pricing Templates"} />
                                        <NavText>
                                            <Link to="/accounting/pricing-templates">Custom Pricing Templates</Link>
                                        </NavText>
                                    </NavItem>
                                )}
                                <NavText>Accounting</NavText>
                            </NavItem>
                        )}
                        {permissionData?.FEATURE_BARCODE?.permissionHave && (
                            <NavItem eventKey="/utilty" active={path.includes("barcode")}>
                                <NavIcon id="utilty">
                                    <div className="mainMenu">
                                        <i
                                            className="fa fa-flask"
                                            style={{ fontSize: "1em" }}
                                            aria-hidden="true"
                                        />
                                    </div>
                                </NavIcon>
                                <NavItem
                                    eventKey="/barcode"
                                    className="menuItem SubMenu"
                                    active={path.includes("barcode")}
                                >
                                    <NavIcon id="uploads">
                                        <Link to="/barcode">
                                            <span>
                                                <i
                                                    className="fa fa-barcode"
                                                    style={{ fontSize: "1em" }}
                                                />
                                            </span>
                                        </Link>
                                    </NavIcon>
                                    <WmsTooltip
                                        anchorId={"uploads"}
                                        place="right"
                                        content={"Company"}
                                    />
                                    <NavText>
                                        <span className="spanWrapper">
                                            <Link to="barcode">Barcode</Link>
                                        </span>
                                    </NavText>
                                </NavItem>

                                <NavItem
                                    eventKey="/pdf-editor"
                                    className="menuItem SubMenu"
                                    active={path.includes("pdf-editor")}
                                >
                                    <NavIcon id="pdf-editor">
                                        <Link to="/pdf-editor">
                                            <span>
                                                <i
                                                    className="fa fa-pencil-square-o"
                                                    style={{ fontSize: "1em" }}
                                                />
                                            </span>
                                        </Link>
                                    </NavIcon>
                                    <WmsTooltip
                                        anchorId={"pdf-editor"}
                                        place="right"
                                        content={"pdf-editor"}
                                    />
                                    <NavText>
                                        <span className="spanWrapper">
                                            <Link to="pdf-editor">PDF Editor</Link>
                                        </span>
                                    </NavText>
                                </NavItem>
                                <NavItem
                                    eventKey="/merge-pdf"
                                    className="menuItem SubMenu"
                                    active={path.includes("merge-pdf")}
                                >
                                    <NavIcon id="merge-pdf">
                                        <Link to="/merge-pdf">
                                            <span>
                                                <i
                                                    className="fa fa-files-o"
                                                    style={{ fontSize: "1em" }}
                                                />
                                            </span>
                                        </Link>
                                    </NavIcon>
                                    <WmsTooltip
                                        anchorId={"pdf-editor"}
                                        place="right"
                                        content={"pdf-editor"}
                                    />
                                    <NavText>
                                        <span className="spanWrapper">
                                            <Link to="merge-pdf">PDF Merge</Link>
                                        </span>
                                    </NavText>
                                </NavItem>
                                <NavText>Utilities</NavText>
                            </NavItem>
                        )}

                        {permissionData?.FEATURE_SETTINGS?.permissionHave && (
                            <NavItem className="mainMenu" eventKey="/setting" active={path === "/setting"}>
                                <NavIcon id="setupIcon">
                                    <Link to="/setting" className="menuOuter">
                                        <i
                                            className="fa fa-fw fa-regular fa-gear"
                                            style={{ fontSize: "1em" }}
                                            aria-hidden="true"
                                        />
                                    </Link>
                                </NavIcon>
                                <WmsTooltip
                                    anchorId={"setupIcon"}
                                    place="right"
                                    content={"Settings"}
                                />
                                <NavText>
                                    <Link to="setting" className="menuOuter">Settings</Link>
                                </NavText>
                            </NavItem>
                        )}

                        {renderReportsSection()}

                    </SideNav.Nav>
                )}
            </SideNav>
        </div >
    );
};

Sidebar.propTypes = {
    sidebarOpen: PropTypes.bool,
};

export default Sidebar;